import { Component, OnInit, ViewChild } from '@angular/core';
import { St4wService } from 'app/core/services/st4w.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UiService } from 'app/core/services/ui.service';
import * as _moment from 'moment';
import { St4w } from '@classes/st4w';

@Component({
  selector: 'app-st4w-grid',
  templateUrl: './st4w-grid.component.html',
  styleUrls: ['./st4w-grid.component.scss']
})
export class St4wGridComponent implements OnInit {

  dataSource = new MatTableDataSource<St4w>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    // 'date',
    'quantity',
    'measureUnit',
    'shipName',
    'origineName',
    'destinationName',
    'orderReference',
    'material',
    // 'gsin',
    'plannedDeliveryDate',
    'plannedDespatchDate',
    // 'st4wIdentifier',
    'updateDate',
    'pickupDate',
    'enRouteDate',
    'dropoffDate',
    'creationDate'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    public st4wService: St4wService,
    public uiService: UiService
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'material': return (element.material?.name);
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.getSt4ws();
  }

  getSt4ws() {
    this.uiService.addRouteLoading();
    this.st4wService.getSt4ws().subscribe(data => {
      this.dataSource.data = data;
      this.uiService.removeRouteLoading();
    }, error => {
      this.uiService.removeRouteLoading();
      console.error(error);
    });
  }

  selectItemClick(item: St4w) {
    this.selectedRowID = item.id || '';
  }
}
